<ng-container *ngIf="!(isLayoutError$ | async); else error">
  <flo-entity-hub-layout
    [selectedItem]="selectedItem$ | async"
    [layout]="layout$ | async"
    [geoBlockedIds]="geoBlockedIds$ | async"
    [imageWithButtons]="imageWithButtons$ | async"
    [description]="description$ | async"
    [selectedTab]="selectedTab$ | async"
    [partial]="partial$ | async"
    [isLoading]="isLoading$ | async"
    [isPartialError]="isPartialError$ | async"
    [message]="message$ | async"
    [adConfigMap]="adConfigs$ | async"
    (lazyLoadedAdRef)="adLoadedOnChildView($event)"
    (tabClicked)="handleTabClicked($event)"
    (nextPage)="handleNextPage($event)"
    (layoutHeaderCtaButton)="handleHeaderCta1ButtonClick($event)"
  >
  </flo-entity-hub-layout>
</ng-container>
<ng-template #error>
  <div class="container bg-white min-vh-100 py-5">
    <flo-error></flo-error>
  </div>
</ng-template>
